export function hideFromWappalyzer() {
  const wnd = window as any;
  wnd._ = null;
  wnd.moment = null;
  document.getElementsByTagName('app-root')[0].setAttribute('ng-version', '');
}
